"use client";

import { STANDALONE_PREFIXES } from "@/constants/routes";
import { usePathname } from "next/navigation";

/**
 * Returns true when the current page is a standalone page (no sidebar, no onboarding, no splash modals).
 * Add new standalone route prefixes to STANDALONE_PREFIXES in constants/routes.ts.
 */
export const useIsStandalonePage = () => {
  const pathname = usePathname();
  return STANDALONE_PREFIXES.some((prefix) => pathname?.startsWith(prefix));
};
